import { FC } from 'react';
import { TCheckedItem } from '../types';
import { CheckedItem } from '../checkedItem/checkedItem';

interface CheckedItemsListProps {
	items: TCheckedItem[];
	checkedItemsIds: number[];
	onSelectItem: (item: TCheckedItem, checked: boolean) => void;
}

export const CheckedItemsList: FC<CheckedItemsListProps> = ({
	items,
	checkedItemsIds,
	onSelectItem,
}) => {
	return (
		<div className="checked-items-list">
			{items.map(item => (
				<CheckedItem
					key={item.id}
					item={item}
					onSelect={onSelectItem}
					checkedItemsIds={checkedItemsIds}
				/>
			))}
		</div>
	);
};
